import { createContext, useContext } from "react";

export interface DetailsPanelRect {
  left: number;
  top: number;
}

export const DetailsPanelContext = createContext<DetailsPanelRect | null>(null);
export const useDetailsPanelRect = () => useContext(DetailsPanelContext);
